import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const Api = {
    get_courses: (): object => {
        return axios.get(`${API_URL}/courses`)
            .then(res => {
                return res.data;
            });
    },

    get_categories: (): object => {
        return axios.get(`${API_URL}/categories`)
            .then(res => {
                return res.data;
            });
    },

    get_localizations: (): object => {
        return axios.get(`${API_URL}/localizations`)
            .then(res => {
                return res.data;
            });
    },

    get_courses_in_time_w_c_ids: (course_ids:string, loc_id?:any): any => {
        loc_id = loc_id == '-1' ? '' : loc_id;
        return axios.get(`${API_URL}/courses/events?course_ids=`+course_ids+`&localization_id=`+loc_id)
            .then(res => {
                return res.data;
            });
    },

    get_courses_in_time: (): object => {
        return axios.get(`${API_URL}/courses/events`)
            .then(res => {
                return res.data;
            });
    },

    get_seats_by_course_city: (course_id: number, city_id: number | null): any => {
        return [
            { "date": "1613487600", "remaining_capacity": "3" },
            { "date": "1613487605", "remaining_capacity": "1" },
            { "date": "1613487601", "remaining_capacity": "1" },
        ];
    },

    send_request: (request: any): Promise<any> => {
        return axios.post(`${API_URL}/reservation`, request)
    }
};
